export default "__VITE_ASSET__Cm_9A4$J__"